import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    BaseEntityResponse,
    CredentialActivityStatus,
    BaseEntitiesResponse,
    CredentialLoginParams,
    CredentialLogin, CredentialType
} from '@base/entities/BaseEntities';
import { APIGatewayService } from '../gateway/APIGateway.service';
import { BaseEndpoint } from '@base/endpoint/BaseEndpoint';
import { DataLoadOptions } from '@base/datalayer/DataLoadOptions';

@Injectable()
export class CredentialActivityEndpoint extends BaseEndpoint {
    //Constructor
    constructor(api: APIGatewayService) {
        super('CredentialActivity', api);
    }

    public ListActivity(CredentialType: number, options: DataLoadOptions): Observable<BaseEntityResponse<CredentialActivityStatus>> {
        return this.api.ExecuteGetAction(
            this.ControllerName,
            'ListActivity',
            { CredentialType: CredentialType, options: options?.GetLoadOptions() });
    }

    public ListCredentialTypes(): Observable<BaseEntitiesResponse<CredentialType>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'ListCredentialTypes');
    }

    public ListLogins(Params: CredentialLoginParams, options: DataLoadOptions): Observable<BaseEntitiesResponse<CredentialLogin>> {
        return this.api.ExecutePostAction(this.ControllerName, 'ListLogins', Params, options?.GetLoadOptions());
    }
}
